import { useState } from "react";
import { NestedItemProps } from "../interface";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { StyledNavItem, StyledNavItemIcon } from "./styles";
import { IconImage } from "../iconImage";
import { Collapse, List, ListItemText } from "@mui/material";

export const NestedListItem = ({ nestedValue, iconSrc, listItems }: NestedItemProps) => {
    const [currentNestedList, setCurrentNestedList] = useState<string>("");

    const handleClickNestedListItem = (value: string) => {
        setCurrentNestedList(currentNestedList && value === currentNestedList ? "" : value);
    }
    return <>
        <StyledNavItem onClick={() => handleClickNestedListItem(nestedValue)}>
            <StyledNavItemIcon>
                <IconImage imageUrl={iconSrc} />
            </StyledNavItemIcon>
            <ListItemText disableTypography primary={nestedValue} />
            {currentNestedList === nestedValue ? <ExpandLess /> : <ExpandMore />}
        </StyledNavItem>
        <Collapse in={currentNestedList === nestedValue} timeout="auto" unmountOnExit>
            <List disablePadding sx={{
                paddingLeft: 2,
                paddingTop: 1,
                paddingRight: 1,
                paddingBottom: 1
            }}>
                {
                    listItems?.map((item) => {
                        return item;
                    })
                }
            </List>
        </Collapse>
    </>
}